import { Component, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { STATES } from '../../../utils/constants';
import { PaymentService } from '../../../services/payment/payment.service';
import { IBillingInformationFormGroup } from '../../../interfaces/IPayments';

@Component({
  selector: 'app-billing-address-info',
  templateUrl: './billing-address-info.component.html',
  styleUrl: './billing-address-info.component.scss'
})
export class BillingAddressInfoComponent {
  billingInformationForm!: FormGroup<IBillingInformationFormGroup>;
  states = STATES;
  constructor(private paymentService: PaymentService) {}

  ngOnInit(): void {
    this.billingInformationForm = this.paymentService.billingInfoForm;
  }

}
